module.exports = __webpack_public_path__ + "img/sms-record.22434f1c.png";